module.exports = __webpack_public_path__ + "media/images/banner_clube_en-2d92fc62318685600e8f307d46d8be40.png";